module.exports = __webpack_public_path__ + "img/wallid-background.3c544d0e.jpg";